export default "__VITE_ASSET__CVUkkQvf__"